import {Component, OnInit} from '@angular/core';
import {ConfService} from "../conf.service";
import {ActivatedRoute} from "@angular/router";
import {ICategory} from "../crudapi/crudapi.component";
import {FormControl} from "@angular/forms";
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

declare let $;
@Component({
  selector: 'app-fabricator',
  templateUrl: './fabricator.component.html',
  styleUrls: ['./fabricator.component.css']
})
export class FabricatorComponent implements OnInit {
    myControl = new FormControl();
    data: any;
    executors: any;
    dataModel: any;
    dataSource: any;
    partner: string;
    account: string;
    entity: string;
    version: string;
    responseSelected: any;
    panelOpenState = false;
    config = {};
    options: any;
    attributes = ['Status', 'Status Message'];
    executorVersions = [
        {name: 'v1'},
        {name: 'v2'},
        {name: 'v3'},
        {name: 'v4'},
        {name: 'v5'},
        {name: 'v6'},
        {name: 'v7'},
        {name: 'v8'},
        {name: 'v9'},
        {name: 'v10'}
    ];
    authModel: any;
    headers = [];
    queryParams = [];
    requestBody = [];
    prerequisites: any;
    responseAttributes = [];
    executorMethods = [{name: 'GET'},{name:'POST'},{name:'PUT'},{name: 'DELETE'}];
    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    scopeSelected = 'public';
    description: string;
    executorCategory: string;
    executor_name: string;
    executor_type: string;
    selectedVersion: string;
    selectedExecutor: string;
    executor_display_name: string;
    filteredOptions: Observable<ICategory[]>;
    query = {
        condition: 'and',
        rules: [
        ]
    };
    operations = {
        "operation_name":"gettestexecutorapimodel1",
        "display_name":"Fetch records",
        "description":"Gets all the records from entity : testexecutorapimodel1",
        "operation_type":"GET",
        "url":"v1/data/salapi/salapi/testexecutorapimodel1",
        "collection_name":"testexecutorapimodel1",
        "parameters":[
            {
                "type":"query",
                "annotation":"RequestParam",
                "name":"query",
                "description":"Query based on attribute values",
                "required":false,
                "allowReserved":false,
                "deprecated":false,
                "schema":{
                    "type":"String"
                }
            },
            {
                "type":"header",
                "annotation":"RequestHeader",
                "name":"pkey",
                "description":"Partner Key",
                "required":true,
                "allowReserved":false,
                "deprecated":false,
                "schema":{
                    "type":"String"
                }
            }
        ],
        "authModel":null,
        "prerequisites":null,
        "notes":null
    };
  constructor(private confPost: ConfService, public platform: LeftpanelComponent) { }
   /*newData = [
      {
          "executor_name": "getEntity",
          "executor_type": "API",
          "httpMethodType": "GET",
          "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/MongoTest",
          "dataroot": null,
          "queryParams": null,
          "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
          "authModel": null,
          "requestBody": null,
          "prerequisites": null
      },
      {
          "executor_name": "IfConditionSample",
          "executor_type": "ControlFlow",
          "control_flow_type": "If",
          "control_flow": [{
              "control_type": "If",
              "conditions": {
                  "operand": "and",
                  "rules": [
                      {
                          "field": "MongoTest",
                          "operator": "=",
                          "value": "String2"
                      }
                  ],

                  "executors": [
                      {
                          "executor_name": "getDynamoTest",
                          "executor_type": "API",
                          "httpMethodType": "GET",
                          "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/DynamoTest",
                          "dataroot": null,
                          "queryParams": null,
                          "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                          "authModel": null,
                          "requestBody": null,
                          "prerequisites": null
                      },
                      {
                          "executor_name": "createItem",
                          "executor_type": "API",
                          "httpMethodType": "POST",
                          "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/MongoTest",
                          "dataroot": null,
                          "queryParams": null,
                          "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                          "authModel": null,
                          "requestBody": {"type":"raw","value":{"getDynamoTest.name":"String4"}},
                          "prerequisites": null
                      }
                  ]
              }
          },
              {
                  "control_type": "Else If",
                  "conditions": {
                      "operand": "and",
                      "rules": [
                          {
                              "field": "MongoTest",
                              "operator": "=",
                              "value": "String2"
                          }
                      ],
                      "executors": [
                          {
                              "executor_name": "getDynamoTest",
                              "executor_type": "API",
                              "httpMethodType": "GET",
                              "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/DynamoTest",
                              "dataroot": null,
                              "queryParams": null,
                              "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                              "authModel": null,
                              "requestBody": null,
                              "prerequisites": null
                          },
                          {
                              "executor_name": "createItem",
                              "executor_type": "API",
                              "httpMethodType": "POST",
                              "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/MongoTest",
                              "dataroot": null,
                              "queryParams": null,
                              "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                              "authModel": null,
                              "requestBody": {"type":"raw","value":{"getDynamoTest.name":"String4"}},
                              "prerequisites": null
                          }
                      ]
                  }
              }
          ]
      }
  ];*/
   newData = [];
  ngOnInit() {

      /*this.newData = [
              {
                  "executor_name": "getEntity",
                  "executor_type": "API",
                  "httpMethodType": "GET",
                  "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/MongoTest",
                  "dataroot": null,
                  "queryParams": null,
                  "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                  "authModel": null,
                  "requestBody": null,
                  "prerequisites": null
              },
              {
                  "executor_name": "IfConditionSample",
                  "executor_type": "ControlFlow",
                  "control_flow_type": "If",
                  "control_flow": [{
                      "control_type": "If",
                      "conditions": {
                          "operand": "and",
                          "rules": [
                              {
                                  "field": "MongoTest",
                                  "operator": "=",
                                  "value": "String2"
                              }
                          ],
                          "executors": [
                              {
                                  "executor_name": "getDynamoTest",
                                  "executor_type": "API",
                                  "httpMethodType": "GET",
                                  "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/DynamoTest",
                                  "dataroot": null,
                                  "queryParams": null,
                                  "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                                  "authModel": null,
                                  "requestBody": null,
                                  "prerequisites": null
                              },
                              {
                                  "executor_name": "createItem",
                                  "executor_type": "API",
                                  "httpMethodType": "POST",
                                  "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/MongoTest",
                                  "dataroot": null,
                                  "queryParams": null,
                                  "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                                  "authModel": null,
                                  "requestBody": {"type":"raw","value":{"getDynamoTest.name":"String4"}},
                                  "prerequisites": null
                              }
                          ]
                      }
                  },
                      {
                          "control_type": "Else If",
                          "conditions": {
                              "operand": "and",
                              "rules": [
                                  {
                                      "field": "MongoTest",
                                      "operator": "=",
                                      "value": "String2"
                                  }
                              ],
                              "executors": [
                                  {
                                      "executor_name": "getDynamoTest",
                                      "executor_type": "API",
                                      "httpMethodType": "GET",
                                      "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/DynamoTest",
                                      "dataroot": null,
                                      "queryParams": null,
                                      "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                                      "authModel": null,
                                      "requestBody": null,
                                      "prerequisites": null
                                  },
                                  {
                                      "executor_name": "createItem",
                                      "executor_type": "API",
                                      "httpMethodType": "POST",
                                      "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/MongoTest",
                                      "dataroot": null,
                                      "queryParams": null,
                                      "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
                                      "authModel": null,
                                      "requestBody": {"type":"raw","value":{"getDynamoTest.name":"String4"}},
                                      "prerequisites": null
                                  }
                              ]
                          }
                      }
                  ]
              }
          ];
*/
      this.partner = localStorage.getItem('partner');
      this.account = localStorage.getItem('account');

      if (this.platform.partnerExecutors !== null && this.platform.partnerExecutors !== undefined) {
          this.executors = this.platform.partnerExecutors;
      } else {
          this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
              .toPromise().then(data => {
              this.executors = data;
              this.platform.partnerExecutors = data;
          });
      }
      // this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
      //     this.options = data;
      //     this.filteredOptions = this.myControl.valueChanges
      //         .pipe(
      //             startWith<string | ICategory>(''),
      //             map(value => typeof value === 'string' ? value : value.name),
      //             map(name => name ? this._filter(name) : this.options.slice())
      //         );
      // });

      // New Implementation but commented
      // if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
      //     this.options = this.platform.partnerCategories;
      // } else {
      //     this.platform.getCategoriesForPartnerAccount();
      //     this.options = this.platform.partnerCategories;
      // }
      // this.filteredOptions = this.myControl.valueChanges
      //     .pipe(
      //         startWith<string | ICategory>(''),
      //         map(value => typeof value === 'string' ? value : value.name),
      //         map(name => name ? this._filter(name) : this.options.slice())
      //     );
  }
   allowDrop(ev) {
    ev.preventDefault();
  }

   drag(ev) {
    ev.dataTransfer.setData("text", ev.target.id);
  }
    /*newDrop(newdata, ev) {
        var that = this;
        var data = ev.dataTransfer.getData("text");
        var text = document.getElementById(data).innerHTML;
        const addData = {
            "executor_name": text,
            "executor_type": "API",
            "httpMethodType": "GET",
            "apiUrl": "https://services.apiplatform.io/v1/data/salapi/salapi/DynamoTest",
            "dataroot": null,
            "queryParams": null,
            "headers": {"pkey": "3fe7b92e1b9d382f3fdaac482c1b8282", "Content-type":"application/json"},
            "authModel": null,
            "requestBody": null,
            "prerequisites": null
        };
        return newdata.push(addData);
    }*/

   drop(ev) {
  //  ev.preventDefault();
    var that = this;
    var data = ev.dataTransfer.getData("text");
    var text = document.getElementById(data).innerHTML;
    if (text.trim() == 'Switch' || text.trim() == 'If else If') {
        this.getCondition(ev, data.trim());
    } else {
        var child = document.createElement('div');
       // child.innerHTML = '<div  draggable="true" > ' + text + '</div>';
        $(child).attr('draggable', true);
        const ide = (text.trim()+this.getId()).replace(' ', '');
        const exp = '<div class="panel-group" id="accordion" style="margin-bottom: 2px;">\n' +
            '        <div class="panel panel-default">\n' +
            '          <div class="panel-heading accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" data-target="#'+ide.trim()+'">\n' +
            '            <h4 class="panel-title">'+text +' <span style="float: right">' +
            '               <i class="fa fa-angle-double-down" style="color: #3c3b3b"></i></span></h4>\n' +
            '\n' +
            '          </div>\n' +
            '          <div id="'+ide.trim()+'" class="panel-collapse collapse">\n' +
            '            <div class="panel-body" style="padding: 0px;">\n' +
            '              <p>sadfsadfsdaf sadf</p>\n' +
            '            </div>\n' +
            '          </div>\n' +
            '        </div>\n' +
            '      </div>';
      //  ev.target.insertAdjacentHTML('beforeend', exp);
      //  this.renderer.invokeElementMethod($(child), 'insertAdjacentHTML' ['beforeend', '<div class="two">two</div>']);
        $(child).append(exp);
        if($(ev.target).attr('class') == 'initializer' ) {
            $(child).attr('id', 'f-i-'+data);
        } else {
            $(child).attr('id', 'f-'+data);
           // $(child).attr('class', 'log-cl');
        }

      //  $(child).append('<span><i class="fa fa-cogs"></i></span>');

      /*  $(child).on('drop dragdrop',function(event){
            that.dropInternal(event.originalEvent);
        });
        $(child).on('dragover',function(event){
            that.allowDrop(event.originalEvent);
        });*/
        $(child).on('dragstart',function(event){
            that.drag(event.originalEvent);
        });
     //   var clone = '<div draggable="true" (dragstart)="drag($event)"> ' + text + '</div>';
        if(data.includes('f-')) {
            if($(ev.target).parent('.connector').length) {
                $(ev.target).closest('.connector').after(document.getElementById(data));
            } else {
                ev.target.closest('.connector').appendChild(document.getElementById(data));
            }
          //  $(ev.target).after(document.getElementById(data));
        } else {
            if($(ev.target).parent('.connector').length) {
                $(ev.target).closest('.connector').after(child);
            } else {
                ev.target.closest('.connector').appendChild(child);
            }

        }
       // this.addNodes(ev.target, [{'condition' : text }]);
    }

   // ev.target.appendChild(document.getElementById(data));
  }
    dropInternal(ev) {
        var that = this;
        var data = ev.dataTransfer.getData("text");
        ev.target.appendChild(document.getElementById(data));

    }
  dropDelete (ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("text");
      document.getElementById(data).remove();
  }

  getCondition(ev, control) {
    let controlFlow = [{
        'name': 'switch',
        'data' : [
            { 'title': 'switch',
                'condition': 'default',
                'value': false
            },
            {
                'condition': 'case',
                'value': false
            }
        ]},{
        'name': 'ifelse',
        'data': [{ 'title': 'If',
            'condition': 'else',
            'value': true
        },
            {
                'condition': 'else If',
                'value': true
            },{
                'condition': '',
                'value': true
            }]
    }];
      const itemDupli = controlFlow.findIndex(p => p.name === control);
      const data = controlFlow[itemDupli];
      this.data = data['data'];
      /*this.data = [
          { 'title': 'If',
              'condition': 'else',
              'value': true
          },
          {
              'condition': 'If else',
              'value': true
          }
      ];*/
      this.getAttributes(ev);
  }
    buildHierarchy(data, ev) {
      var that = this;
        var $title = $('<table class="fabricator-content"><tr> <td class="title"> <i class="exp-col fa fa-angle-double-down"></i>' + data[0].title +
            '<i class="del fa fa-trash"></i><span class="right"><i class="add-node fa fa-plus-square" ></i></span></td>' +
            ' </tr></table>');
        $title.find('.exp-col').click(function(){
            $(this).parent('td').closest('tr').siblings().toggle();
            $(this).toggleClass("fa-angle-double-down fa-angle-double-up");
        });
        $title.find('.del').click(function(){
            if($(this).parent('td').closest('tr').closest('.fabricator-content').closest('.flow-connector').length){
                $(this).parent('td').closest('tr').closest('.fabricator-content').closest('.flow-connector').remove();
            } else {
                $(this).parent('td').closest('tr').closest('.fabricator-content').remove();
            }
        });
        $title.find('.add-node').click(function(){
            if($(this).closest('tr').next().find('.connector').length) {
                that.addNodes($(this).closest('tr').next(), [data[1]]);
            } else {
                that.addNodes($(this).parent().closest('tr'), [data[1]]);
            }
        });
        let colspan = 3;

        let width = 95;
        if(data[0].value){
            width = 70;
        }

        var $test = $('<td><div class="operator-cl" style="display: initial"><select class="attribute_sel" style="width: '+ width +'%;"><option value="status">Status</option>');
        for (let key in this.dataModel) {
            const $option = $('<option value="'+ key +'"> '+ key + '</option>');
            $test.find('.attribute_sel').append($option);
        }
        $test.append('</select></div> <i class="fa fa-angle-down"></i> </td>');
        $test.find('i').click(function(){
           that.addOperations($(this));
        });
        if(data[0].value) {
            colspan = 3;
            $test.find('.operator-cl').prepend('<select style="margin-right: 3px;width:23%"><option>=</option><option>contains</option><option>!=</option></select>');
        //    $test.find('select').closest('td').closest('tr').append('<td><input type="text" class="form-control" ></td>')
        }


        $title.find('.title').after($test);
        if(data[0].value) {
            $title.find('.title').after('<td><input type="text" class="form-control" ></td>');
        }
//<tr style="border: none"><td style="text-align: center"><i class="fa fa-angle-double-down"></i>' +
//                '</td></tr>
        if($(ev.target).closest('#accordion').closest('tr').length) {
           const $test =  $('<tr class="flow-connector"><td style="padding-left: 10px;" colspan="'+colspan+'" class="content"></td></tr>');
           const $appendTest = $test.find('.content').append($title);
                 $(ev.target).closest('#accordion').closest('tr').after($test);
        } else {
            $(ev.target).after($title);
        }


        this.addNodes($title.find('.title').closest('tr'), data);
    }
    addNodes(ev, data){
        var that = this;
        data.forEach(function(item) {
            if(item.condition != '') {
                var $table = $('<tr>\n' +
                    '    <td class="box">\n' +
                    item.condition +
                    '<span class="right" >' +
                    '<i class="fa fa-trash" style="color: #9c9898;"></i></span></td></tr>');
                let check = true;
                let colspan = 3;
                if(item.condition == 'else') {
                    check = false;
                    colspan = 3;
                }
                let width = 100;
                if(item.value){
                    width = 75;
                }
                if(check) {
                    $table.append('<td>' +
                        '<input class="form-control" style="width: '+ width +'%;" type="text">' +
                        '</td>');
                }

                if(item.value && check) {
                    colspan = 3;
                    $table.find('.box').after('<td><div class="operator-cl" style="display: initial">' +
                        '<input type="text" class="form-control" ></div></td>');
                    $table.find('.box').siblings('td:last').find('.operator-cl').prepend('<select style="margin-right: 3px;"><option>=</option><option>contains</option><option>!=</option></select>');
                }

                $table.find('i').click(function(){
                    $(this).parent().closest('tr').next('tr').remove();
                    $(this).parent().closest('tr').remove();
                });
                if(item.title == 'If'){
                  //  $pipe.after($table);
                     ev.after($table);
                } else {
                    ev.after($table);
                }

            }
            let colspan = 3;
            var $pipe = $('<tr>\n' +
                '    <td id="'+that.getId()+'" class="connector" colspan='+colspan+'>\n' +
                '\n' +
                '    </td>\n' +
                '  </tr>');
            $pipe.find('.connector').on('drop',function(event){
                that.drop(event.originalEvent);
            });
            $pipe.find('.connector').on('dragover',function(event){
               // event.preventDefault();
                that.allowDrop(event.originalEvent);
            });
            if(item.condition == '') {
                ev.after($pipe);
            } else {
                $table.after($pipe);
            }

        });
    }
    getId() {
        return (new Date().getTime()) * 1000 + Math.floor(Math.random() * 1001);
    }
    getEntity(val) {
        const data = val.split('#');
        /* var str = Object.values(val).toString();
         return str.substr(0, str.indexOf('.')).toString();*/
        return data[0];
    }
    getAttributes(ev) {
     // const entity = $('.initializer').find('div').text().trim();
        /*const entity = 'TestAccount';
        this.confPost.getPartnerEntity(this.account, entity, this.partner).subscribe(items => {
            this.dataSource = items[0].attributes;
            this.getDataModel(ev);
        });*/
    }
    getDataModel(ev) {
        this.dataModel = {};
        const that = this;
        this.dataSource.forEach((data) => {
            if (data.type != 'Array') {
                this.dataModel[data.attributeName] = data.type;
            } else {
                this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
            }
        });
        this.buildHierarchy(this.data, ev);
        return this.dataModel;
    }

    getSub(data) {
        const subType = [];
        const obj = {};
        const that = this;
        if (data.length > 0) {
            data.forEach((result) => {
                if (result.type != 'Array') {
                    obj[result.attributeName] = result.type;
                } else {
                    obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
                }
            });
            subType.push(obj);
        }
        return subType;
    }
    addOperations(ev){
        let cl = ev.closest('td').find('.operator-cl:eq(0)').clone();
        let prevcl = ev.closest('td').prev().find('input:eq(0)').clone();
        const $remove = $('<i class="fa fa-angle-double-down"></i>');
        $(cl).next($remove);
        ev.closest('td').append(cl);
        ev.closest('td').prev().append(prevcl);
       // cl.remove();
    }
    toggle(ev){
       // ev.target.click(function(){
        $(ev.target).parent('td').closest('tr').siblings().toggle();
        $(ev.target).toggleClass("fa-angle-double-down fa-angle-double-up");
       // });
    }
    deleteExecutor(data, i){
        const index: number = i;
        if (index !== -1) {
            data.splice(index, 1);
        }
        return data;
    }
    saveFab() {
       const fabResult = {
           "executor_type": this.executor_type,
           "executor_name": this.executor_name,
           "executor_version": this.selectedVersion,
           "executor_display_name": this.executor_display_name,
           "executor_description": this.description,
           "executor_category": this.executorCategory,
           "executor_scope": this.scopeSelected,
           "executor_method_type": this.selectedExecutor,
           "queryParams": this.queryParams,
           "headers": this.headers,
           "authModel": this.authModel,
           "requestBody": this.requestBody,
           "prerequisites": this.prerequisites,
           "executors": this.newData
       };
    }
    newDrop(newdata, ev) {

        var that = this;
        var data = ev.dataTransfer.getData("text");
        var text = document.getElementById(data).innerHTML;
        let addData;
        if(text.trim() == 'If else If') {
            addData = {
                "executor_name": "IfConditionSample",
                "executor_type": "ControlFlow",
                "control_flow_type": "If",
                "control_flow": [{
                    "control_type": "If",
                    "conditions": {
                        condition: "and",
                        rules: [
                        ]
                    },
                        "executors": [
                        ]

                },
                    {
                        "control_type": "Else If",
                        "conditions": {
                            condition: "and",
                            rules: [
                            ]
                        },
                            "executors": [
                            ]
                    }
                ]
            };
        } else if(text.trim() == 'Switch') {
            addData = {
                "executor_name": "SwitchConditionSample",
                "executor_type": "ControlFlow",
                "control_flow_type": "Switch",
                "control_flow": [{
                    "control_type": "Switch",
                    "conditions": {
                        condition: "and",
                        rules: [
                        ]
                    },
                        "executors": [
                        ]

                },
                    {
                        "control_type": "Case",
                        "conditions": {
                            condition: "and",
                            rules: [
                            ]
                        },
                            "executors": [
                            ]
                    },
                    {
                        "control_type": "Default",
                        "conditions": {
                            condition: "and",
                            rules: [
                            ]
                        },
                            "executors": [
                            ]

                    }
                ]
            };
        } else {
            const category = that.getCat(data);
            const fdata = this.executors[category].executors.findIndex(p => p && p.executor_name === text.trim());
            addData = this.executors[category].executors[fdata];
            addData.mapping = [{"key": null, "value": null}];
            addData.crAttributes = [];
            addData.responseAttributes.forEach((attr) => {
                if(attr != 'undefined' || attr != null) {
                    that.getNodeAttributes(addData.executor_name, attr);
                    that.getAttr(addData.crAttributes, attr);
                }
            });
        }
        return newdata.push(addData);
    }

    getNodeAttributes(exName, data) {
       const that = this;
       if(data.subType == null) {
           this.responseAttributes.push(exName +'.'+data.attributeName);
           this.config[exName +'.'+data.attributeName]
               = {name: exName +'.'+data.attributeName , type:
                   (data.type.toLowerCase() == 'integer' ? 'number' :
                       (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
       } else {
           data.subType.forEach((sub) => {
               if(sub.subType == null) {
                   this.responseAttributes.push(exName +'.'+data.attributeName + '.' + sub.attributeName);
                   this.config[exName +'.'+data.attributeName + '.' + sub.attributeName]
                       = {name: exName +'.'+data.attributeName + '.' + sub.attributeName , type:
                           (data.type.toLowerCase() == 'integer' ? 'number' :
                               (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
               } else {
                   that.getLeafAttributes(exName +'.'+data.attributeName, sub);
               }
           });
       }
    }
    getLeafAttributes(parent, data) {
       const that = this;
        if(data.subType == null) {
            this.responseAttributes.push(parent + '.' + data.attributeName);
            this.config[parent + '.' + data.attributeName]
                = {name: parent + '.' + data.attributeName , type:
                    (data.type.toLowerCase() == 'integer' ? 'number' :
                        (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    this.responseAttributes.push(parent + '.' +data.attributeName + '.' + sub.attributeName);
                    this.config[parent + '.' +data.attributeName + '.' + sub.attributeName]
                        = {name: parent + '.' +data.attributeName + '.' + sub.attributeName , type:
                            (data.type.toLowerCase() == 'integer' ? 'number' :
                                (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
                } else {
                    that.getLeafAttributes(parent + '.' +data.attributeName, sub);
                }
            });
        }
    }
    getAttr(parent, data) {
        const that = this;
        let responseAttributes = [];
        if(data.subType == null) {
            parent.push(data.attributeName);
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    parent.push(data.attributeName + '.' + sub.attributeName);
                } else {
                    that.leafattr(parent, data.attributeName, sub);
                }
            });
        }
    }
    leafattr(p, parent, data){
        const that = this;
        if(data.subType == null) {
            p.push(parent + '.' + data.attributeName);
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    p.push(parent + '.' +data.attributeName + '.' + sub.attributeName);
                } else {
                    that.leafattr(p,parent + '.' +data.attributeName, sub);
                }
            });
        }
    }
    addRules(data, i){
       data.push(data[0]);
    }
    removeRules(data, i){
        const index: number = i;
        if (index !== -1) {
            data.splice(index, 1);
        }
    }
    addCfSub(type, data) {
       let datacfl;
       if(type == 'If') {
           datacfl = {
               "control_type": "Else If",
               "conditions": {
                   condition: "and",
                   rules: [
                   ]
               },
               "executors": [
               ]
           };
           data.push(datacfl);
       } else if (type == 'Switch'){
           datacfl = {
               "control_type": "Case",
               "conditions": {
                   condition: "and",
                   rules: [
                   ]
               },
               "executors": [
               ]
           };
           data.splice( 1, 0,datacfl);
       }
    }
    executorToggle(ev) {
        $(ev.target).parent('.category').next('.items').toggle();
        $(ev.target).toggleClass("fa-angle-double-right fa-angle-double-down");
    }
    getCat(val){
       const result = val.split('_');
       return result[0];
    }
    stringifyjson(val) {
        return JSON.stringify(val, null, 2).trim();
    }
    filterSearch() {
        var filter = $('.filterText').val().toUpperCase();
        $('.category').each(function() {
            var text = $(this).text().trim().toUpperCase();
            if(text.indexOf(filter) > -1) {
                $(this).show();
                $(this).next('.items').show();
            } else {
                $(this).hide();
                $(this).next('.items').hide();
            }
        });
    }
    private _filter(name: string): ICategory[] {
        const filterValue = name.toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }
    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }
    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass("fa-chevron-down fa-chevron-up");
    }
    addMapping(data) {
       const map = {"key": null, "value": null};
       data.push(map);
    }
    removeMapping(data, index) {
        if (index !== -1) {
            data.splice(index, 1);
        }
    }
    toggleExecutorIn(ev){
        $(ev.target).parent('div').siblings('.expansion-collapse').slideToggle();
        $(ev.target).toggleClass("fa-chevron-down fa-chevron-up");
    }
}
